<template>
  <div id="googleMapContainer">
    <div
      class="col-12 d-flex align-items-center justify-content-center mapOverlay"
      v-if="this.loading"
    >
      <div class="d-flex flex-column">
        <Spinner></Spinner>
      </div>
    </div>

    <div
      class="col-12 d-flex align-items-center justify-content-center mapOverlay"
      v-else-if="this.listings.length === 0"
    >
      <div class="d-flex flex-column">
        <div class="text-center">
          <i class="fas fa-exclamation-circle fa-8x" style="color: white"></i>
          <p style="color: white">{{ $t("common.placeholders.noResults") }}</p>
        </div>
      </div>
    </div>

    <GmapMap
      ref="gmap"
      class="google-map m-0 mb-12"
      :center="{ lat: 46.0037, lng: 8.9511 }"
      :zoom="18"
      map-type-id="roadmap"
      style="height: 100%"
      :options="{
        panControl: true,
        zoomControl: true,
        mapTypeControl: true,
        scaleControl: true,
        streetViewControl: true,
        overviewMapControl: true,
        clickableIcons: false,
        styles: [
          {
            featureType: 'poi.business',
            stylers: [{ visibility: 'off' }],
          },
        ],
      }"
    >
      <!--  Create the markers -->
      <google-marker
        v-for="(m, i) in markers"
        :key="i"
        :position="m.position"
        :clickable="true"
        @click="selectMarker(m)"
        :icon="customMarker"
      />

      <!-- Create the info window -->
      <gmap-info-window
        v-if="currentMarker"
        :options="infoOptions"
        :position="currentMarker.position"
        :opened="currentMarker !== undefined"
      >
      </gmap-info-window>
    </GmapMap>
  </div>
</template>

<script>
import Spinner from "@/components/common/Spinner";

export default {
  name: "MapContainer",
  components: {
    Spinner,
  },
  props: {
    listings: {
      required: true,
      default: function () {
        return undefined;
      },
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  watch: {
    listings: function () {
      // Any time the listings are updated, recalc the markers
      if (!this.isUndefined(this.listings)) {
        this.computeMarkers();
        this.fitBounds();
      }
    },
  },
  methods: {
    fitBounds: function () {
      if (this.isUndefined(this.markers)) {
        return;
      }
      this.$refs.gmap.$mapPromise.then((map) => {
        const bounds = new google.maps.LatLngBounds();

        for (let m of this.markers) {
          let c = { lat: m.position.lat, lng: m.position.lng };
          bounds.extend(c);
        }
        map.fitBounds(bounds);
      });
    },
    panToCoordinate: function (coords) {
      if (this.isUndefined(coords)) {
        return;
      }
      this.$refs.gmap.$mapPromise.then((map) => {
        map.panTo(coords);
      });
    },
    computeMarkers: function () {
      console.log("compute markers called");
      if (this.isUndefined(this.listings)) {
        return [];
      }

      let mks = this.listings
        .filter((lst) => !this.isUndefined(lst.address))
        .filter(
          (lst) =>
            lst.address.latitude !== null && lst.address.longitude !== null
        )
        .map((lst) => {
          return {
            position: {
              lat: lst.address.latitude,
              lng: lst.address.longitude,
            },
            infoWindow: {
              name: this.$options.filters.localized(lst.localizedName),
              localizedName: lst.localizedName,
              objectId: lst.objectId,
              image: `${this.resolveImage(lst.images[0], "thumb")}`,
            },
          };
        });

      this.markers = mks;
    },
    selectMarker: function (marker) {
      this.currentMarker = marker;
    },
    closeInfoWindow: function () {
      this.currentMarker = undefined;
    },
    goToListing: function (objectId) {
      let routeData = this.$router.resolve(`/${objectId}`);
      window.open(routeData.href, "_blank");
    },
  },
  computed: {
    areListingsUndefined: function () {
      return this.isUndefined(this.listings);
    },
    customMarker: function () {
      return `${process.env.BASE_URL}casafile_marker.png`;
    },
    infoOptions: function () {
      if (!this.currentMarker) {
        return {};
      }

      const contentString = `
            <div id="gm-custom-info-container">
                <div class="gm-custom-card">
                    <div class="gm-custom-card-img-container">
                        <img src="${
                          this.currentMarker.infoWindow.image
                        }" class="gm-custom-card-img-top">
                    </div>
                    <div class="gm-custom-card-body">
                        <h6 class="gm-custom-card-subtitle">${this.$i18n.t(
                          "common.keywords.listing"
                        )} ${this.currentMarker.infoWindow.objectId}</h6>
                        <h5 class="gm-custom-card-title">${this.$options.filters.localized(
                          this.currentMarker.infoWindow.localizedName
                        )}</h5>
                    </div>
                    <div class="gm-custom-card-button-container">
                        <div class="gm-custom-card-column">
                        <button class="btn gm-custom-card-button gm-custom-card-button-outline" type="button" onclick="closeWindow()">${this.$i18n.t(
                          "common.actions.close"
                        )}</button>
                        </div>
                        <div class="gm-custom-card-column">
                            <button class="btn gm-custom-card-button" type="button" onclick="visitListing(${
                              this.currentMarker.infoWindow.objectId
                            })">${this.$i18n.t("common.actions.view")}</button>
                        </div>
                    </div>
                </div>
            </div>`;

      return {
        content: contentString,
        maxWidth: 200,
        maxHeight: 250,
        pixelOffset: {
          width: 0,
          height: -50,
        },
      };
    },
  },
  mounted() {
    const vm = this;
    window.closeWindow = function () {
      vm.closeInfoWindow();
    };

    window.visitListing = function (objectId) {
      vm.goToListing(objectId);
    };
  },
  data() {
    return {
      markers: [],
      currentMarker: undefined,
      shape: {
        coords: [10, 10, 10, 15, 15, 15, 15, 10],
        type: "poly",
      },
    };
  },
};
</script>

<style lang="scss">
#gm-custom-info-container {
  width: 200px !important;
  height: 250px;

  border-radius: 5px;
}

.gm-custom-card {
  height: 100%;

  &-body {
    padding: 5px;
  }

  &-img-container {
    display: grid;
    align-content: center;
  }

  &-img-top {
    height: 140px;
    margin: auto;
    width: auto;
  }

  &-title {
    margin: 0px;
    max-height: 36px;
    overflow: hidden;
  }

  &-subtitle {
    margin: 0;
    color: #999 !important;
    font-weight: 400;
  }

  &-button-container {
    display: flex;
    flex-direction: row;

    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
  }

  &-column {
    width: 50%;
    padding: 5px;
  }

  &-button {
    width: 100%;
    border-radius: 5px;
    color: white;

    &-outline {
      color: $primary-color;
      background-color: white !important;
      border: 1px solid $primary-color !important;
    }
  }
}

.gm-style-iw {
  width: 250px !important;
  border-radius: 5px;
}

.gm-style-iw-d > div {
  width: 200px !important;
}

.gm-style-iw.gm-style-iw-c {
  border-radius: 5px !important;
}
</style>

<style lang="scss" scoped>
#googleMapContainer {
  width: 100%;
  height: 100%;
}
.mapOverlay {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
}
</style>
